<a href="/espace-client/#/dashboard/global">
  <pr-icon
    name="sp-house"
    class="pr-icon-o"
    [viewBoxWidth]="24"
    [viewBoxHeight]="24"
  ></pr-icon>
</a>
@for (link of links; track link; let last = $last) {
  <pr-icon name="arrow_forward" class="arrow"></pr-icon>
  @if (link.url) {
    <a [href]="link.url" [ngClass]="{ last: last }">{{ link.label }}</a>
  }
  @if (!link.url) {
    <a [ngClass]="{ last: last }">{{ link.label }}</a>
  }
}
